import SnackbarComponent, { SNACKBAR_DISMISS_EVENT } from '../Snackbar';

export const ERROR_DISMISS_EVENT = 'error-dismiss';

export class ErrorSnackbarComponent extends SnackbarComponent {
	static key = 'lta-error-snackbar';

	get defaultType() {
		return 'alert';
	}

	get defaultIcon() {
		return 'alert';
	}

	get defaultButtonLabel() {
		return 'Close';
	}

	get defaultLabelClasses() {
		return 'title error-text';
	}

	get defaultButtonClass() {
		return 'js-dismiss-error';
	}

	get dismissEventName() {
		return ERROR_DISMISS_EVENT;
	}
}

export { SNACKBAR_DISMISS_EVENT };
export default ErrorSnackbarComponent;
